import apiClient from './api_client_requests';
import { getCookieByName } from './cookies';

export default (config) => {
    return async (payload) => {
        const appCookieKey = 'tokenCookie';
        const sharedCookieKey = 'AuthToken';

        const jwtFromCookie = getCookieByName(appCookieKey);
        const sharedCookie = getCookieByName(sharedCookieKey);

        if (jwtFromCookie && sharedCookie) {
            const wholeTokenFromCookie = JSON.parse(sharedCookie);

            let spatFromCookie = wholeTokenFromCookie.spat;

            let result = await apiClient(config).apiMethod({
                method: 'GetRafCode',
                headers: {
                    'X-Auth-Token': jwtFromCookie,
                    'X-Auth-Spat': spatFromCookie,
                },
                args: {
                    ...payload,
                },
            });

            return result;
        } else {
            return {};
        }
    };
};
